import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import './plugins/iview.js'
import iView from 'iview'
import 'iview/dist/styles/iview.css';

import VueI18n from 'vue-i18n';
import enLocale from 'iview/dist/locale/en-US';
import zhLocale from 'iview/dist/locale/zh-CN';

//自己设置的多语言
import cn from "./language/zh-CN";
import us from "./language/en-US";

// 引用API文件
import api from './api/http.js'
// 将API方法绑定到全局
Vue.prototype.$api = api

import Axios from 'axios'

//解决跨域问题
Vue.prototype.$axios = Axios
Axios.defaults.baseURL = '/api'
Axios.defaults.headers.post['Content-Type'] = 'application/json';

Vue.config.productionTip = false
Vue.use(VueI18n);
Vue.use(iView);
Vue.locale = () => {};

const messages = {
  zh: Object.assign(cn, zhLocale),
  en: Object.assign(us, enLocale)
};

// 设置参数，创建 Vuei18n 的实例。
const i18n = new VueI18n({
  locale: "en", // 默认英文
  //locale: localStorage.getItem("language") || "en", // 默认英文
  messages // set locale messages
});

var vm=new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

